// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1NUx0","actions":"GroupTable_actions__t08Y9","deleteModalFooter":"GroupTable_deleteModalFooter__1LrSg"};